module.exports = __webpack_public_path__ + "assets/01.eb1fd2d5.pdf";